import React from 'react'

interface PremiumBannerProps {
  isPremium: boolean
  onUpgrade: () => void
}

const PremiumBanner: React.FC<PremiumBannerProps> = ({ isPremium, onUpgrade }) => {
  if (isPremium) {
    return (
      <div className="card" style={{ background: 'linear-gradient(135deg, #ffd700, #ffed4e)' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
          <span style={{ fontSize: '2rem' }}>⭐</span>
          <div>
            <h3 style={{ margin: 0, color: '#5a4a00' }}>Garden Planner Solo Member</h3>
            <p style={{ margin: '0.25rem 0 0 0', color: '#5a4a00' }}>
              You have unlimited access to all premium features!
            </p>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="card" style={{ background: 'linear-gradient(135deg, #2d5a27, #4a7c43)', color: 'white' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '1rem' }}>
        <div>
          <h3 style={{ margin: 0 }}>🌟 Upgrade to Garden Planner Solo</h3>
          <p style={{ margin: '0.5rem 0 0 0', opacity: 0.9 }}>
            Get unlimited gardens, all 200+ plants, advanced features, and exclusive content.
          </p>
          <ul style={{ margin: '0.5rem 0 0 0', paddingLeft: '1.5rem', opacity: 0.9, fontSize: '0.9rem' }}>
            <li>Unlimited garden designs</li>
            <li>Complete plant database (200+ varieties)</li>
            <li>Advanced companion planting AI</li>
            <li>Harvest tracking & reports</li>
            <li>Priority weather alerts</li>
            <li>Exclusive video content from Muddy Boots Ranch</li>
            <li>Direct Q&A with gardening experts</li>
          </ul>
        </div>
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: '2rem', fontWeight: 'bold' }}>$29</div>
          <div style={{ fontSize: '0.9rem', opacity: 0.9 }}>per month</div>
          <button 
            className="btn"
            style={{ 
              marginTop: '0.75rem',
              background: 'white',
              color: '#2d5a27',
              fontWeight: 600
            }}
            onClick={onUpgrade}
          >
            Upgrade Now
          </button>
        </div>
      </div>
    </div>
  )
}

export default PremiumBanner
